export class HttpNoNetworkConnectionError extends Error {
  public wasCaught = false;

  constructor() {
    super('No network connection');
  }
}
